import { createAsyncThunk } from '@reduxjs/toolkit';
import { getSPAApiURLForTenant } from '@qb/frontend/utils/hosts/apiHost';
import { getHostFromWindow } from '@qb/frontend/utils/hosts/getHostFromWindow';
import {
  SocketGetRequest,
  SocketGetRequestWithData,
} from '@qb/httpRequest/SocketRequest';
import {
  ConversationDisplayDataResponse,
  ConversationListDataResponse,
  ConversationSearchResponse,
} from '@/shared/types/controllers/ConversationControllerTypes';

export const SEARCH_TEXT_MIN_LENGTH = 3;

const fetchConversationData = createAsyncThunk<
  {
    conversation: ConversationDisplayDataResponse['conversation'];
    setAsSelected: boolean;
  },
  { conversationID: number; setAsSelected: boolean; tenantAlias: string }
>(
  `/conversation/:id/displayData`,
  async ({ conversationID, setAsSelected, tenantAlias }) => {
    return new Promise((resolve, reject) => {
      if (conversationID) {
        SocketGetRequest(
          `${getSPAApiURLForTenant(
            tenantAlias,
            getHostFromWindow(),
          )}/conversation/${conversationID}/displayData`,
          (data: ConversationDisplayDataResponse) => {
            return resolve({ ...data, setAsSelected });
          },
          (err: Error) => {
            console.error(err);
            reject(err);
          },
        );
      } else {
        return reject();
      }
    });
  },
);

const fetchConversationListData = createAsyncThunk<
  ConversationListDataResponse,
  { page: number; tenantAlias: string }
>(`/conversation/listData`, async ({ page, tenantAlias }) => {
  return new Promise((resolve, reject) => {
    SocketGetRequestWithData(
      `${getSPAApiURLForTenant(
        tenantAlias,
        getHostFromWindow(),
      )}/conversation/listData`,
      { page: page },
      resolve,
      reject,
    );
  });
});

const fetchConversationsBySearch = createAsyncThunk<
  ConversationSearchResponse,
  { searchTerm: string; tenantAlias: string }
>(`/conversation/search`, async ({ searchTerm, tenantAlias }) => {
  return new Promise((resolve, reject) => {
    if (searchTerm.trim().length < SEARCH_TEXT_MIN_LENGTH) {
      resolve({ searchConversationResults: [] });
      return;
    }
    SocketGetRequestWithData(
      `${getSPAApiURLForTenant(
        tenantAlias,
        getHostFromWindow(),
      )}/conversation/search`,
      { searchTerm: searchTerm },
      resolve,
      reject,
    );
  });
});

export {
  fetchConversationData,
  fetchConversationListData,
  fetchConversationsBySearch,
};
